export function dataURLtoFile(dataUrl: string, filename: string): File | null {
    let dataUrlParts = dataUrl.split(',');

    if (dataUrlParts.length < 2)
        return null;

    let matches = dataUrlParts[0].match(/:(.*?);/);

    if (matches == null || matches.length < 2) return null;

    let mime = matches[1];

    let imageBase64 = atob(dataUrlParts[dataUrlParts.length - 1]);

    let n = imageBase64.length;
    let imageBytes = new Uint8Array(n);
    while (n--) {
        imageBytes[n] = imageBase64.charCodeAt(n);
    }

    return new File([imageBytes], filename, {type: mime});
}
